import activations from '@/locales/en/activations.js';
import deliveries from '@/locales/en/deliveries.js';
import pagination from '@/locales/en/pagination.js';
import auth from './auth.js';
import orders from './orders.js';
import dashboard from './dashboard.js';

export default {
    auth,
    orders,
    activations,
    deliveries,
    pagination,
    dashboard,
    global: {
        general: {
            cancel: 'Cancel',
            select: 'Select...',
        },
        nav: {
            dashboard: 'Dashboard',
            orders: 'Orders',
            activations: 'Activations',
            deliveries: 'Deliveries',
        },
        setting: {
            dropdown: {
                disconnect: 'Log out',
                setting: 'Setting',
            },
        },
        status: {
            pending: 'Pending validation',
            validated: 'Validated',
            completed: 'Completed',
        },
        pagination: {
            results: 'Results',
            resultsString: '{name} {start}-{end} of {total}',
        },
        platform: {
            android: 'Android',
            pc: 'PC',
            oem: 'OEM',
        },
    },
};
